import { computed } from 'vue';
import { useHamburgerMenu } from './useHamburgerMenu';
import { useMeta } from './useMeta';

function getCategoryListFromMenuByIds(menu, ids) {
  return ids.reduce((acc, id) => {
    const category = menu[id];

    if (category) {
      acc.push(category);
    }

    return acc;
  }, []);
}

export function useHamburgerTopMenu() {
  const { menu } = useHamburgerMenu();
  const { meta } = useMeta();
  const topMenuCategories = computed(() => {
    const { topGroupsMenu = [] } = meta.value.properties || {};

    return topGroupsMenu.reduce((acc, cur) => {
      const { title, ids } = cur;
      const data = getCategoryListFromMenuByIds(menu.value, ids);

      if (!data.length) return acc;

      const group = { title, data };

      return acc.concat(group);
    }, []);
  });

  return { topMenuCategories };
}
